import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { useMedia } from 'react-use';

import {
  UserProfilePage,
  UserProfileSettingsPage,
  UserProfileCalendarsPage,
  UserProfileSubscriptionPage,
  UserProfileCommunitiesPage,
  NotificationsPage,
  SubscriptionsPage,
  SubscriptionInner,
  UserProfileEvents,
  PersonalChat,
} from 'pages';
import { ROUTES, PROFILE_ROUTES } from 'configs';
import { breakpoints } from 'theme';
import { ProfileSidebarMobile, ProfileMenu } from 'components';

const ProfileRouter = () => {
  const isWide = useMedia(breakpoints.md);

  return (
    <>
      {isWide ? <ProfileMenu /> : <ProfileSidebarMobile />}
      <Routes>
        <Route path="*" element={<UserProfilePage />} />

        <Route
          path={PROFILE_ROUTES.SETTINGS}
          element={<UserProfileSettingsPage />}
        />

        <Route
          path={PROFILE_ROUTES.CALENDAR_CONNECTION}
          element={<UserProfileCalendarsPage />}
        />

        <Route
          path={`${PROFILE_ROUTES.SUBSCRIPTION}/${PROFILE_ROUTES.PLANS}/:subscriptionId`}
          element={<SubscriptionInner />}
        />

        <Route
          path={`${PROFILE_ROUTES.SUBSCRIPTION}/${PROFILE_ROUTES.PLANS}`}
          element={<SubscriptionsPage />}
        />

        <Route
          path={PROFILE_ROUTES.SUBSCRIPTION}
          element={<UserProfileSubscriptionPage />}
        />

        <Route
          path={PROFILE_ROUTES.COMMUNITIES}
          element={<UserProfileCommunitiesPage />}
        />

        <Route path={ROUTES.EVENTS} element={<UserProfileEvents />} />

        <Route
          path={PROFILE_ROUTES.NOTIFICATIONS}
          element={<NotificationsPage />}
        />
        <Route path={PROFILE_ROUTES.CHAT} element={<PersonalChat />} />
        {/* <Route
          path={`${PROFILE_ROUTES.CHAT}/:conversationId`}
          element={<PersonalChat />}
        /> */}
        {/* <Route
          path={`${ROUTES.MESSAGE}/:userId`}
          element={<PrivateChatPage />}
        /> */}
      </Routes>
    </>
  );
};

export default ProfileRouter;
